export default __webpack_public_path__ + "static/userexperience1-39cb5a15f5de56882af022b0afe3925b.png";